<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="1000"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" label-position="top">
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 审计记录</template>
                            <Row :gutter="16" style="margin-bottom: 20px;">
                                <Col span="24">
                                    <Button type="primary" icon="ios-search" @click="addLog()">添加审计记录</Button>
                                </Col>
                            </Row>
                            <template v-for="(item, index) in Forms.audit_list" :key="index">
                                <Row :gutter="16">
                                    <Col span="4">
                                        <FormItem label="审计类型" :prop="'audit_list.' + index + '.type_id'" :rules="{required: true,type:'number' , message: '必填', trigger: 'change',transform(value) { return parseInt(value)}}">
                                            <Select v-model="item.type_id" filterable clearable placeholder="审计类型">
                                                <Option v-for="(items,indexs) in auditList" :key="indexs" :value="items.type_id">{{items.name}}</Option>
                                            </Select>
                                        </FormItem>
                                    </Col>
                                    <Col span="3">
                                        <FormItem label="审计金额" :prop="'audit_list.' + index + '.money'" :rules="{required: true,type:'number' , message: '必填', trigger: 'blur', transform(value) { return parseFloat(value)}}">
                                            <Input v-model="item.money" type="number" clearable placeholder="0.00" />
                                        </FormItem>
                                    </Col>
                                    <Col span="3">
                                        <FormItem label="审计总金额" :prop="'audit_list.' + index + '.total_money'" :rules="{required: true,type:'number' , message: '必填', trigger: 'blur', transform(value) { return parseFloat(value)}}">
                                            <Input v-model="item.total_money" type="number" clearable placeholder="0.00" />
                                        </FormItem>
                                    </Col>
                                    <Col span="3">
                                        <FormItem label="项目总审计额" :prop="'audit_list.' + index + '.project_money'" :rules="{required: true,type:'number' , message: '必填', trigger: 'blur', transform(value) { return parseFloat(value)}}">
                                            <Input v-model="item.project_money" type="number" clearable placeholder="0.00" />
                                        </FormItem>
                                    </Col>
                                    <Col span="3">
                                        <FormItem label="审计公司" :prop="'audit_list.' + index + '.audit_company'" :rules="{required: true, message: '必填', trigger: 'blur'}">
                                            <Input v-model="item.audit_company" clearable placeholder="" />
                                        </FormItem>
                                    </Col>
                                    <Col span="4">
                                        <FormItem label="审计时间" :prop="'audit_list.' + index + '.audit_time'" :rules="{required: true, type:'date', message: '必填', trigger: 'change'}">
                                            <DatePicker type="date" format="yyyy-MM-dd" v-model="item.audit_time" placeholder="审计时间" class="width-100"  />
                                        </FormItem>
                                    </Col>
                                    <Col span="3">
                                        <FormItem label="操作" >
                                            <Button type="error" ghost @click="delLog(index)">删除</Button>
                                        </FormItem>
                                    </Col>
                                </Row>
                            </template>
                        </Card>
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 审计信息</template>
                            <Row :gutter="32">
                                <Col span="12">
                                    <FormItem label="最终审计金额" prop="audit_money" :rules="{required: true, type:'number', message: '必填', trigger: 'blur', transform(value) { return parseFloat(value)}}">
                                        <Input v-model="Forms.audit_money" type="number"  clearable placeholder="最终审计金额" />
                                    </FormItem>
                                </Col>
                                <Col span="12">
                                    <FormItem label="审计时间" prop="audit_time" :rules="{required: true, type:'date', message: '必填', trigger: 'change'}">
                                        <DatePicker type="date" format="yyyy-MM-dd" v-model="Forms.audit_time" placeholder="审计时间" class="width-100"  />
                                    </FormItem>
                                </Col>
                                <Col span="24">
                                    <FormItem label="备注信息" prop="remark">
                                        <Input v-model="Forms.remark" type="textarea" :rows="8" clearable placeholder="备注信息" />
                                        <small class="text-danger">提示：请勿删除原有备注信息</small>
                                    </FormItem>
                                </Col>
                            </Row>

                        </Card>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">确认结束</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import { selectAuditTypeList, auditProject} from "@/apis/project";

export default {
    name: 'ProjectAudit',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '项目审计',
            isBox : false,
            auditList: [],
            Forms : {
                project_id: '',
                audit_list: [],
                audit_money: '',
                audit_time: '',
                remark: '',
            }
        }
    },
    methods: {
        addLog(){
            let that = this;
            that.Forms.audit_list.push({
                id:'',
                type_id:'',
                money:'',
                total_money:'',
                project_money:'',
                audit_company:'',
                audit_time:''
            });
        },
        delLog(index){
            let that = this;
            that.Forms.audit_list.splice(index, 1);
        },
        getConfig(){
            let that = this;
            selectAuditTypeList().then(e=>{
                that.auditList = e.data ?? [];
            })
        },
        /**
         功能：
         time: 2025/12/17 10:47
         **/
        show(project_id, name){
            this.isBox = true;
            this.title = name + ' - 项目审计';
            this.getConfig();
            if(project_id){
                this.Forms.project_id = project_id;
            }
        },
        /**
         功能：
         time: 2025/12/20 09:24
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    auditProject(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2025/12/20 11:54
         **/
        FormReset(){
            this.isBox = false;
            this.title = '项目审计';
            this.$refs['Forms'].resetFields();
            this.Forms.project_id = '';
            this.Forms.audit_list = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
